<!--suppress HtmlUnknownTarget -->
<template lang="pug">

    div

        step-indicator(v-bind:activeStep='1')

        .ui.five.cards

            card(name='Plakate' forms-key="plakate")
                img(src='../../../assets/icons/plakate.png')

            card(name='Flyer / Faltblätter' forms-key="flyer-faltblaetter")
                img(src='../../../assets/icons/flyerfaltblaetter.png')

            card(name='Fotosatz / lose Blattsammlung' forms-key="fotosatz-lose-blattsammlung")
                img(src='../../../assets/icons/fotosatzloseblattsammlung.png')

            card(name='Broschuren / Pressehefte / Kataloge' forms-key="broschuren-pressehefte-kataloge")
                img(src='../../../assets/icons/broschurenpresseheftkataloge.png')

            card(name='Gutscheine / Karten' forms-key="gutscheine-karten")
                img(src='../../../assets/icons/gutscheinekarten.png')

            card(name='CD / DVD Produktion & Zubehör' forms-key="cd-dvd")
                img(src='../../../assets/icons/cddvdproduktionzubehoer.png')

            card(name='Beileger / Booklets' forms-key="beileger-booklets")
                img(src='../../../assets/icons/beilegerbooklets.png')

            card(name='Banner' forms-key="banner")
                img(src='../../../assets/icons/banner.png')

            card(name='Aufsteller / Displays' forms-key="aufsteller-displays")
                img(src='../../../assets/icons/aufstellerdisplays.png')

            card(name='Standee' forms-key="aufsteller-displays/standee" parent="aufsteller-displays")
                img(src='../../../assets/icons/standee.png')

            card(name='Deckenhänger' forms-key="aufsteller-displays/deckenhaenger" parent="aufsteller-displays")
                img(src='../../../assets/icons/deckenhaenger.png')

            card(name='Säule' forms-key="aufsteller-displays/saeule" parent="aufsteller-displays")
                img(src='../../../assets/icons/saeule.png')

            card(name='Verkaufsdisplay' forms-key="aufsteller-displays/verkaufsdisplay" parent="aufsteller-displays")
                img(src='../../../assets/icons/verkaufsdisplay.png')

            card(name='Roll-Up Display' forms-key="aufsteller-displays/roll-up-display" parent="aufsteller-displays")
                img(src='../../../assets/icons/display.png')

            card(name='Geschäftsausstattung' forms-key="geschaeftsausstattung")
                img(src='../../../assets/icons/geschaeftsausstattung.png')

            card(name='Blöcke' forms-key="geschaeftsausstattung/bloecke" parent="geschaeftsausstattung")
                img(src='../../../assets/icons/bloecke.jpg')

            card(name='Briefbögen' forms-key="geschaeftsausstattung/briefboegen" parent="geschaeftsausstattung")
                img(src='../../../assets/icons/briefboegen.jpg')

            card(name='Briefhüllen / -umschläge' forms-key="geschaeftsausstattung/briefhuellen-umschlaege" parent="geschaeftsausstattung")
                img(src='../../../assets/icons/briefhuellenumschlaege.jpg')

            card(name='Visitenkarten' forms-key="geschaeftsausstattung/visitenkarten" parent="geschaeftsausstattung")
                img(src='../../../assets/icons/visitenkarten.jpg')

            card(name='Präsentationsmappen' forms-key="geschaeftsausstattung/praesentationsmappen" parent="geschaeftsausstattung")
                img(src='../../../assets/icons/praesentationsmappen.jpg')

            card(name='Aufkleber / Etiketten' forms-key="aufkleber-etiketten")
                img(src='../../../assets/icons/aufkleberetiketten.png')

            card(name='Etiketten auf Rolle' forms-key="aufkleber-etiketten/etiketten-auf-rolle" parent="aufkleber-etiketten")
                img(src='../../../assets/icons/etikettenaufrolle.png')

            card(name='Etiketten auf Bogen' forms-key="aufkleber-etiketten/etiketten-auf-bogen" parent="aufkleber-etiketten")
                img(src='../../../assets/icons/etikettenaufbogen.png')

            card(name='Aufkleber auf Bogen' forms-key="aufkleber-etiketten/aufkleber-auf-bogen" parent="aufkleber-etiketten")
                img(src='../../../assets/icons/aufkleberaufbogen.png')

            card(name='Aufkleber' forms-key="aufkleber-etiketten/aufkleber" parent="aufkleber-etiketten")
                img(src='../../../assets/icons/aufkleber.png')

            card(name='Großaufkleber' forms-key="aufkleber-etiketten/grossaufkleber" parent="aufkleber-etiketten")
                img(src='../../../assets/icons/grossaufkleber.png')

            card(name='Kalender' forms-key="kalender")
                img(src='../../../assets/icons/kalender.png')

            card(name='Terminkalender fester Einband' forms-key="kalender/terminkalender-fester-einband" parent="kalender")
                img(src='../../../assets/icons/terminkalenderfestereinband.png')

            card(name='Terminkalender weicher Einband' forms-key="kalender/terminkalender-weicher-einband" parent="kalender")
                img(src='../../../assets/icons/terminkalenderweichereinband.png')

            card(name='Wand- / Tischkalender' forms-key="kalender/tischkalender" parent="kalender")
                img(src='../../../assets/icons/wandtischkalender.png')

            card(name='Bücher' forms-key="buecher")
                img(src='../../../assets/icons/buecher.png')

            card(name='Hardcover - Buch' forms-key="buecher/hardcover-buch" parent="buecher")
                img(src='../../../assets/icons/hardcoverbuch.png')

            card(name='Softcover - Buch' forms-key="buecher/softcover-buch" parent="buecher")
                img(src='../../../assets/icons/softcoverbuch.png')

            card(name='Textilien' forms-key="textilien")
                img(src='../../../assets/icons/textilien.png')

            card(name='Konfektionierung' forms-key="konfektionierung")
                img(src='../../../assets/icons/konfektionierung.png')


</template>

<script>
    import StepIndicator from '@/components/products/StepIndicator'
    import Card from '@/components/products/TypeCard'
    import { PRODUCT_TYPE_ID_TO_FORMS_KEY } from '@/utils/product/type'

    export default {

        components: { Card, StepIndicator },

        created() {
            this.handleRoutingBasedOnTypeId(this.$route.params.key)
        },

        methods: {

            handleRoutingBasedOnTypeId(key) {
                const parents = [
                    'aufsteller-displays',
                    'geschaeftsausstattung',
                    'aufkleber-etiketten',
                    'kalender',
                    'buecher'
                ]

                // Umgekehrtes Mapping: formsKey → Typ-ID
                const backendRelations = Object.fromEntries(
                    Object.entries(PRODUCT_TYPE_ID_TO_FORMS_KEY).map(([id, key]) => [key, Number(id)])
                )

                // Pruefen ob aktuelle Typ eine Parent-Typ ist
                if (key !== undefined && !parents.includes(key)) {
                    const id = backendRelations[key]

                    // Typ laden
                    this.$store.dispatch('productTypes/loadOne', { id }).then(() => {
                        // Store vorbereiten
                        this.$store.commit('products/RESET_DRAFT')

                        // Produkttyp setzen
                        const draft = this.$store.getters['products/draft']
                        this.$store.commit('products/REPLACE_DRAFT', { draft: { ...draft, type: id }})

                        // Formular-Key holen
                        //const key = this.$store.getters['productTypes/byId'](id).formsKey

                        // Weiterleiten
                        this.$router.replace({
                            name: 'products/create/step2',
                            params: { key }
                        })
                    })

                }

            }

        },

        watch: {

            '$route.params.key'(key) {
                this.handleRoutingBasedOnTypeId(key)
            }

        }

    }

</script>
